import React from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const ModalAddons = () => null;

const Nav: React.FC<Props> = ({ children, className }) => <div className={classNames('modal-addons-nav', className)}>{children}</div>;

const Tabs: React.FC<Props> = ({ children, className }) => <div className={classNames('modal-addons-tabs', className)}>{children}</div>;

ModalAddons.Nav = Nav;
ModalAddons.Tabs = Tabs;

export default ModalAddons;
